module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Wand.7fb643e6.png";